export default class videoModal {

    constructor() {
        this.settings = {
            'videoCarousels': document.querySelectorAll('.wp-block-mission-resource-video-carousel')
        }
    }

    init() {

        if( 0 == this.settings.videoCarousels.length )
          return;

        this.bindUIActions();

    }

    bindUIActions() {

        // Get all carousels on the page
        let videoCarousels = document.querySelectorAll('.wp-block-mission-resource-video-carousel');

        this.createModal();

        // Loop through and add modal events for each video in the carousel
        videoCarousels.forEach( carousel => {
            let videos = carousel.querySelectorAll('.video-cover');
            videos.forEach( video => this.addModalEvent(video) );
        });

    }

    // Create modal El and append to page
    createModal() {

        let modal = document.createElement('div');

        modal.setAttribute( 'class', 'video-modal' );
        document.querySelector('body').appendChild( modal );

        let modalInner = document.createElement('div');
        modalInner.setAttribute( 'class', 'video-modal__inner' );
        modal.appendChild( modalInner );

        let modalCloseButton = document.createElement('button');
        modalCloseButton.setAttribute( 'class', 'video-modal__close' );

        modalCloseButton.innerHTML = `
            <span class="button-text">Close</span>
            <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true" role="img"><use href="#icon--close"></use></svg>`;

        modal.appendChild( modalCloseButton );

        modalCloseButton.addEventListener('click', () => {
            modalInner.innerHTML = '';
            modal.classList.remove('video-modal--active');
        } );

    }

    // Populate the modal with the appropriate video content
    addModalEvent( video ) {

        let button = video.querySelector('.video-embed-play');
        let iframe = video.dataset['videoEmbed'];
        let modal  = document.querySelector('.video-modal');
        let modalInner = modal.querySelector('.video-modal__inner');

        button.addEventListener( 'click', function (e) {
            modal.classList.add('video-modal--active');

            modalInner.innerHTML += iframe;
            let vid = modal.querySelectorAll('iframe')[0];

            let player = new YT.Player(vid.id, {
                events: {
                    'onReady': onPlayerReady
                }
            });

            function onPlayerReady( event ) {
                modal.classList.add('video-modal--active');
                event.target.playVideo();
            }

        });

    }

}